import React from 'react';
import AppRoutes from './navigation/AppRoutes';

function App() {
  return (
    <React.Fragment>
      <AppRoutes />
    </React.Fragment>
  );
}

export default App;

